import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Navigate } from "react-router-dom";
import { Button, Checkbox, Label, TextInput } from "flowbite-react";
import { logo } from "../../images";
import { loginUser } from "../../redux/slices/auth";
import { getStorageToken } from "../../config/firebase";
import { AiOutlineLoading } from "react-icons/ai";

const Login = () => {
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.auth);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    await dispatch(loginUser({ email, password, rememberMe }));
  };

  const shouldRedirectToHome = () => {
    return getStorageToken();
  };

  return shouldRedirectToHome() ? (
    <Navigate to="/" replace />
  ) : (
    <section className="bg-gray-50 dark:bg-gray-900">
      <div className="flex flex-col items-center justify-center px-6 py-8 mx-auto md:h-screen lg:py-0">
        <div className="flex items-center mb-6 text-2xl font-semibold text-purple-00 dark:text-white font-display">
          <img className="w-8 h-8 mr-2" src={logo} alt="logo" />
          PurplebookNG Admin
        </div>
        <div className="w-full bg-white rounded-lg shadow dark:border md:mt-0 sm:max-w-md xl:p-0 dark:bg-gray-800 dark:border-gray-700">
          <div className="p-6 space-y-4 md:space-y-6 sm:p-8">
            <h1 className="text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl dark:text-white font-display">
              Sign in to your account
            </h1>

            <form
              className="flex max-w-md flex-col gap-4"
              onSubmit={handleSubmit}
            >
              <div>
                <div className="mb-2 block">
                  <Label htmlFor="email1" value="Your email" />
                </div>
                <TextInput
                  id="email1"
                  type="email"
                  placeholder="example@purplebook.ng"
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
              <div>
                <div className="mb-2 block">
                  <Label htmlFor="password1" value="Your password" />
                </div>
                <TextInput
                  id="password1"
                  type="password"
                  placeholder="••••••••"
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>
              <div className="flex items-center gap-2">
                <Checkbox
                  id="remember"
                  color="purple"
                  onChange={(e) => setRememberMe(e.target.checked)}
                />
                <Label htmlFor="remember">Remember me</Label>
              </div>
              <Button
                type="submit"
                color="purple"
                disabled={loading}
                isProcessing={loading}
                processingSpinner={
                  <AiOutlineLoading className="h-6 w-6 animate-spin" />
                }
              >
                {loading ? "Logging in..." : "Login"}
              </Button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Login;
